exports.onServiceWorkerUpdateReady= () => window.location.reload();